import { RussianMessagesType } from 'providers/i18n/types';
import englishMessages from 'ra-language-english';

// Типизация строится на основе объекта с русскими переводами
// Если есть ключ с русским переводом, то должен быть и ключ с английским
export const customEnglishMessages: RussianMessagesType = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    navigation: {
      ...englishMessages.ra.navigation,
      no_results: 'No results',
    },
  },
  app: {
    merchantsShowNotifications: {
      accessSettingsDeletionError: 'Failed to delete the access setting',
      accessSettingsDeletedSuccessfully: 'The access setting has been deleted successfully',
      allAccessSettingsCreated: 'All access settings have been created successfully!',
      archiveCommissionErr1: 'The commission',
      archiveCommissionErr2:
        'cannot be archived because it is used in one or more order-routing rules. Disable the commission settings in the routing settings and try again.',
      permanentlyArchived1: 'The commission',
      permanentlyArchived2:
        'will be permanently archived and cannot be used again.This action cannot be undone.',
      archiveCommission: 'Archive commission',
      afterFeeConfirmation1: 'After confirmation, the commission',
      afterFeeConfirmation2:
        'will be submitted to the responsible finance manager for approval.  You will be able to edit or delete it only if it is rejected. You can add a comment before submitting for approval.',
      sendFeeForApproval: 'Submit commission for approval',
      createCommissionRecalculation: 'Create a commission recalculation task?',
      notificationsGuide: {
        title: 'Notifications Setup Guide',
        intro:
          'The system lets you create and configure notifications for a merchant. To set up notifications, follow these steps:',
        step1: 'Click “Add” to open the “Create Notification” form.',
        step2: 'Specify the ID of the Reddy chat where notifications should be sent.',
        step3: 'Select the events that will trigger the notification.',
        eventsInfo: 'The list of available events may be updated with new ones.',
        step4: 'Click “Save”.',
        backButton: 'Back',
      },
      notificationTest: {
        title: 'Notification delivery test:',
        step1: {
          before: 'Go to the ',
          action: '"View Notification Settings" form',
        },
        step2: {
          before: 'Select the ',
          action: '"Send Test Message" function',
        },
        step3: 'Make sure the notification has been delivered to the specified Reddy chat.',
        ifNotReceived: 'If you didn’t receive the notification:',
        fix1: 'Check the notification settings and update them if needed.',
        fix2: 'If the problem persists, contact the system administrator.',
        conclusion:
          'This process helps to ensure the merchant is promptly informed about important events.',
      },
      testMessage: 'Test message',
      notificationSettingsView: 'Notification settings',
      testMessageSent:
        'A test message was sent using the current access settings. If you haven`t received the message, it is necessary to update access settings and try again.',
      sendTestMessage: 'Sending test message',
      editNotificationSettings: 'Edit notification settings',
      enable: 'Enable',
      notificationWillBeTemporarily1: 'The notification',
      notificationWillBeTemporarily2: 'will be temporarily enabled.',
      notificationWillBeTemporarily3: 'will be temporarily disabled.',
      enableNotificationSettings: 'Enable notification settings',
      disableNotificationSettings: 'Disable notification settings',
      notificationSettingsDeletionMessage1: 'Notification settings ',
      notificationSettingsDeletionMessage2:
        ' will be permanently deleted. This action cannot be undone.',
      notificationSettingsDeletionTitle: 'Delete notification settings',
      notificationSettingsCreation: 'Create notification settings',
      testNotificationSendingError: 'Failed to send the test notification',
      testNotificationSent: 'The test notification has been sent successfully!',
      notificationSettingsUpdated: 'Notification settings updated',
      notificationSettingsEnabled: 'Notification settings enabled',
      notificationSettingsDisabled: 'Notification settings disabled',
      notificationSettingsDeleted: 'Notification settings deleted',
      notificationSettingsDeletionError: 'Failed to delete the notification settings',
      notificationSettingsCreationError: 'Failed to create the notification settings',
      notificationSettingsCreated: 'Notification settings created',
      rejectionReasons: 'Refusal reasons',
      orderConversions: 'Order conversion monitoring',
      token: 'Token',
      channelId: 'Reddy chat ID',
      notificationType: 'Notification type',
      deliveryChannel: 'Delivery channel',
      deliveryAddress: 'Delivery address',
      notificationSettings: 'Notification settings',
      noNotificationSettings:
        'No notification settings have been configured for the merchant %{name}.',
      active: 'Active',
    },
    merchantAccess: {
      reset: 'Reset',
      firstName: 'First name',
      lastName: 'Last name',
      assignmentDate: 'Assignment date',
      noAccessAddedForMerchant: 'User access to merchant %{merchantName} is not configured',
      merchantAccessSettings: 'Merchant access settings',
    },
    merchantCommissions: {
      autoCreateRefundAndChargeback: 'Auto-create commissions for Refund and Chargeback',
      afterFeeApproval2:
        'After confirmation, the commission %{name}  will be activated and will apply to new “Orders" from now on.',
      activateCommissionError1: 'The commission',
      activateCommissionError2:
        'cannot be activated because it is not used in any order-routing rules.',
      activateCommission: 'Activate commission',
      afterFeeApproval1: 'After confirmation, the commission',
      afterFeeApproval3:
        'will be approved and become available for configuration and use in the system.',
      confirmFeeApproval: 'Approve commission?',
      feeReturned1: 'After confirmation, the commission',
      feeReturned2:
        'will be rejected and returned to the responsible payments manager for revision. You can add a comment before confirming the rejection.',
      approvalRequestRejection: 'Reject commission',
      noCommissionRecalculationTasks: 'No commission recalculation tasks',
      clickToUpload: 'Choose a file',
      orDragFile: 'or drag it here',
      createNewVersion: 'Create a new version',
      feeComments: 'Comments to the commission',
      fieldsRequiredForGeneration: 'To generate a name, you need to fill in the fields',
      generateName: 'Generate a name',
      reference: {
        title: 'Commission setup and usage guide',

        intro1:
          'The system provides a commission management workflow that includes creation, configuration, approval, activation, and archiving.',
        intro2: 'Commissions can be:',

        types: {
          regular: 'regular;',
          parent: 'parent;',
          child: 'child;',
          ladder: 'tiered commissions.',
        },

        description: {
          parent: {
            name: 'Parent commission',
            text: 'cannot be created manually: a regular commission becomes a parent commission after a child commission is created based on it.',
          },
          child: {
            name: 'Child commission',
            text: 'is created as a new version of a regular or parent commission.',
          },
          ladder: {
            name: 'Tiered commission',
            text: 'is used to configure tier-based commission conditions. It cannot be a parent commission, and a child commission cannot be created based on it. This tab only allows tiered commissions to be viewed. Creation, configuration, approval, activation, and archiving of tiered commissions are available in the "Commissions" subsection only to finance managers.',
          },
        },

        intro3: 'Commissions go through the following statuses:',

        statuses: {
          new: {
            name: 'New',
            text: 'the commission has been created but has not been submitted for approval;',
          },
          inApproval: {
            name: 'In approval',
            text: 'the commission is being reviewed by the responsible approvers;',
          },
          rejected: {
            name: 'Rejected',
            text: 'the commission has not been approved;',
          },
          approved: {
            name: 'Approved',
            text: 'the commission has been approved and is ready for activation;',
          },
          annulled: {
            name: 'Annulled',
            text: 'the commission has been declared invalid;',
          },
          activated: {
            name: 'Activated',
            text: 'the commission has been successfully activated;',
          },
          archived: {
            name: 'Archived',
            text: 'the completed commission has been moved to the archive.',
          },
        },

        roles: {
          paymentsManager: {
            title: 'Role: Payments Department Manager',
            intro1:
              'The Payments Department Manager can perform the following actions with commissions:',
            intro2: {
              before: 'If the commission is configured for a',
              merchant: '"Merchant"',
              between: 'without the',
              partner: '"Partner"',
              after:
                'attribute, the Payments Department Manager can complete the entire approval process independently, without the involvement of a Finance Department Manager.',
            },
            intro3:
              'The Payments Department Manager can perform the following actions with commission recalculation tasks:',

            actions: {
              create: {
                name: 'Create a commission',
                text: 'initiates a new commission by adding the required information;',
              },
              submit: {
                name: 'Submit for approval',
                text: 'moves the commission to the "In approval" status. The Finance Department Manager is notified that the commission requires approval;',
              },
              editRejected: {
                name: 'Edit a rejected commission',
                text: 'after the commission is rejected by the Finance Department Manager, it can be edited and resubmitted for approval;',
              },
              deleteRejected: {
                name: 'Delete a rejected commission',
                text: 'a rejected commission can be deleted if necessary;',
              },
              annul: {
                name: 'Annul an approved commission',
                text: 'moves an approved commission to the "Annulled" status;',
              },
              activate: {
                name: 'Activate a commission',
                text: 'to move a commission to the "Activated" status, it must be configured in the order execution routing rules in the payment aggregator. After the configuration is completed, the commission is moved to the "Activated" status. A child commission can be activated using the "Activate" action when the required conditions are met;',
              },
              archive: {
                name: 'Archive a commission',
                text: 'completes work with the commission by moving it to the archive.',
              },
            },

            recalculationActions: {
              create: 'Create a recalculation task in a child commission;',
              view: 'View a recalculation task in a child commission;',
              edit: 'Edit a recalculation task in a child commission;',
              delete: 'Delete a recalculation task in a child commission.',
            },
          },

          financeManager: {
            title: 'Role: Finance Department Manager',
            intro1:
              'The Finance Department Manager participates in the approval process for commissions created by Payments Department Managers:',
            intro2:
              'The Finance Department Manager can also perform the following actions with commissions:',
            intro3:
              'The Finance Department Manager can perform the following actions with commission recalculation tasks:',
            intro4:
              'When a recalculation task is run, the system recalculates commission values for orders within the specified period. If the task is run for an approved child commission associated with a previously activated related commission, the child commission is activated automatically and starts being used when new orders are created.',

            actions: {
              approve: {
                name: 'Approve a commission',
                text: 'approves the commission and moves it to the "Approved" status;',
              },
              reject: {
                name: 'Reject a commission',
                text: 'rejects the commission and moves it to the "Rejected" status. The Payments Department Manager is notified that the commission must be updated or deleted.',
              },
            },

            extraActions: {
              create: 'Create a commission;',
              approve: 'Submit for approval;',
              editReject: 'Edit a rejected commission;',
              deleteReject: 'Delete a rejected commission;',
              annulApproved: 'Annul an approved commission;',
            },

            extraActionsWithDefenition: {
              activate: {
                name: 'Activate a commission',
                text: 'the Finance Department Manager can activate only a child commission;',
              },
              archive: {
                name: 'Automatically archive a commission',
                text: 'when the Finance Department Manager activates a new child commission, the previously activated related commission is automatically moved to the "Archived" status by the system.',
              },
            },

            recalculationActions: {
              create: 'Create a recalculation task in a child commission;',
              view: 'View a recalculation task in a child commission;',
              edit: 'Edit a recalculation task in a child commission;',
              delete: 'Delete a recalculation task in a child commission.',
              run: 'Run a recalculation task in a child commission.',
            },
          },
        },

        actions: {
          back: 'Back',
        },
      },
      feeEditing: 'Edit commission',
      itemUpdated: 'Commission **%{name}** updated',
      itemDeleted: 'Commission **%{name}** deleted',
      feeDeletion: 'Delete commission',
      feeWillBeDeleted:
        'The commission %{name} will be permanently deleted. This action cannot be undone.',
      newFeeVersionCreation: 'Create a new version of the commission',
      createAlert3: 'The new version of the commission',
      createAlert4:
        'has been created successfully. You can submit it for approval or return to the commission list.',
      createAndApprove: 'Создать и согласовать',
      newFeeCreation: 'Create new commission',
      createAlert1: 'The new commission',
      createAlert2:
        'has been created successfully. You can submit it for approval or return to the commission list.',
      view: 'View',
      backToList: 'Back to list',
      feeCreationSuccessful: 'Commission created successfully',
      feeConditions: 'Commission tеrms',
      activePeriodSettings:
        'Effective period settings determine the commission’s start and end dates.',
      additionalSettings: 'Additional settings',
      basicSettings: 'General settings',
      fix: 'Fixed',
      max: 'Max',
      min: 'Min',
      activePeriod: 'Activity period',
      child: 'Child',
      type: 'Commission type',
      parentFeeId: 'Parent commission ID',
      feeId: 'Commission ID',
      noFeesForAvailable:
        'No commissions have been created for the available merchants or providers',
      emptyMerchantAccess:
        'No merchants are available for user %{firstName} %{lastName}. Please contact your system administrator to configure access settings.',
      emptyProviderAccount:
        'User %{firstName} %{lastName} doesn\'t have access to "Commission" settings. Contact your team lead to request access.',
      feesList: 'The list of commissions',
      commissionCancelDialog: {
        title: 'Annul commission',
        message1: 'On confirmation, the commission',
        message2:
          'will be annuled and cannot be resubmitted for approval. This action cannot be undone.',
        message3: 'You can add a comment before confirming the annulment.',
      },
      feeCreateSuccessDialog: {
        title: 'Commission created successfully',
        newFee: 'The new commission',
        created:
          'has been created. You can submit it for approval or return to the commission list.',
        createdApproved:
          'has been successfully created with the status “Approved”. This commission cannot be edited, but you can cancel it if necessary.',
      },
    },
    limits: {
      gatewayCurrencyLimit1: 'Limit in currency %{currencyName} for gateway',
      gatewayCurrencyLimit2: 'will be permanently deleted. This action cannot be undone.',
      limitUpdatedSuccess: 'Limit updated',
      editLimit: 'Edit limit',
      presetsHint: 'Enter a list of presets separated by spaces.',
      deleteLimit: 'Delete limit',
      createLimit: 'Create limit',
      formInvalid: 'The form has been filled in incorrectly. Please check the errors',
      limitCreatedSuccess: 'Limit created',
      limitDeletedSuccess: 'Limit deleted',
      show: {
        title: 'Limit details',
      },
      limits: 'Limits',

      gateway: 'Gateway',
      currency: 'Currency',

      minDepositAmount: 'Min deposit amount',
      maxDepositAmount: 'Max deposit amount',
      minWithdrawalAmount: 'Min withdrawal amount',
      maxWithdrawalAmount: 'Max withdrawal amount',

      depositAmountPresets: 'Deposit amount presets',
      withdrawalAmountPresets: 'Withdrawal amount presets',

      createdAt: 'Created',
      updatedAt: 'Updated',

      merchantHasNoLimits: 'Limits have not been added for the merchant %{merchantName}.',
    },
    provider: {
      providerView: 'Provider details',
    },
    orderAdjustmentsReference: {
      title: 'Information note',
      subtitle: 'Types of order adjustment',

      intro1:
        'The **"Adjustment Settings"** button is available if at least one order is selected, and there is at least one adjustment type available for all selected orders. If there is no such adjustment type, the selected orders cannot be adjusted within a single operation, so the button is unavailable.',
      intro2:
        'In the **"Order Adjustment Settings"** form, only adjustment types applicable to all selected orders are available for selection.',

      type1Title: '1. Order amount adjustment',
      type1Description:
        'This type is applied to the orders with the status **"Successful"** and with the direction **"Deposit"** and **"Withdrawal"**.',
      result: 'Result:',
      type1Result1: 'Adjusts the order amount (increase or decrease).',
      type1Result2: 'The updated amount is shown in the **merchant account**.',
      type1Result3:
        'Additionally (depending on the setting **"Client balance adjustment"**), the adjustment may affect the player balance.',

      type2Title: '2. Set status "Successful"',
      type2Description:
        'This type is applied to the orders with the status **"Pending"**, **"Failed"**, **"Expired"** and with the direction **"Deposit"** and **"Withdrawal"**.',
      type2Result1: 'Changes the order status to **"Successful"**.',
      type2Result2: 'Credits the order amount to the merchant account.',
      type2Result3:
        'Additionally (depending on settings), the adjustment may affect the player balance.',

      type3Title: '3. Set status "Refund"',
      type3Description:
        'This type is applied to the orders with the status **"Successful"** and with the direction **"Deposit"**.',
      type3Result1: 'Changes the order status to **"Refund"**.',
      type3Result2: 'Debits the order amount from the merchant account.',
      type3Result3:
        'Additionally (depending on settings), the adjustment may affect the player balance.',

      type4Title: '4. Set status "Chargeback"',
      type4Description:
        'This type is applied to the orders with the status **"Successful"** and with the direction **"Deposit"**.',
      type4Result1: 'Changes the order status to **"Chargeback"**.',
      type4Result2: 'Debits the order amount from the merchant account.',
      type4Result3:
        'Additionally (depending on settings), the adjustment may affect the player balance.',

      type5Title: '5. Set status "Failed"',
      type5Description:
        'This type is applied to the orders with the status **"Prepared"**, **"Pending"**, **"Successful"** and with the direction **"Deposit"** and **"Withdrawal"**.',
      type5Result1: 'Changes the order status to **"Failed"**.',
      type5Result2:
        'For the orders in the status **"Successful"** debits the order amount from the merchant account.',
      type5Result3:
        'For the orders in the status **"Pending"** cancels the order without debiting.',
      type5Result4:
        'Additionally (depending on settings), the adjustment may affect the player balance.',

      type6Title: '6. Set status "Cancelled"',
      type6Description:
        'This type is applied to the orders with the status **"Created"** and with the direction **"Deposit"** and **"Withdrawal"**.',
      type6Result1: 'Changes the order status to **"Cancelled"**.',
      type6Result2: 'Cancels the order without debiting.',

      back: 'Back',
    },
    gateway: {
      supportedCurrencies: 'Supported currencies',
      defaultCurrency: 'Default currency',
      deactivationReason: 'Deactivation reason',
      gatewayView: 'Gateway details',
      orderExpirationTimeSec: 'Order validity period (sec)',
      saveCustomerMethodData: 'Save method details',
      statusRequestEnabled: 'Order status polling',
      transactionRequestMaxAttempts: 'Max polling attempts',
      statusPollingInterval: 'Polling interval',
      externalAlias: 'External alias',
    },
    merchantAccounts: {
      accessEditing: 'Edit access',
      accessEnable: 'Enable access',
      subagentId: 'Subagent ID',
      active: 'Active',
      activityUpdatedSuccessfully: 'Account activity for **%{name}** updated',
      currency: 'Currency',
      enableAccountAccess: 'Enable account access',
      generateAccountNameHint:
        'You can generate the account name after selecting Provider and Currency.',
      yes: 'Yes',
      updated: 'Updated',
      lastUpdated: 'Last activity',
      created: 'Created',
      add: 'Add',
      accountAccessWithParams: 'Access to the account {json}',
      useMerchantIdForProviderOrdersHint:
        'If enabled, orders, created by the provider, will be created with the merchant ID',
      close: 'Close',
      useGlobalIdCreate: 'To use the global ID',
      useGlobalIdView: 'Global ID',
      view: 'View',
      merchant: 'Merchant',
      noAccountsForMerchant: 'Accounts have not been added for the merchant %{merchantName}.',
      disableBankOperationsHint:
        'Can be set in settings of any "Merchant" (not only for Partner merchant). If enabled, you cannot create or edit "Bank operation" for this account.',
      name: 'Name',
      noAccess: 'NO ACCESS',
      cancel: 'Cancel',
      reset: 'Reset',
      partner: 'Partner',
      show: 'Show',
      provider: 'Provider',
      merchantAccountDetails: 'Merchant account details',
      editAccountAccess: 'Edit account access',
      editMerchantAccount: 'Edit merchant account',
      edit: 'Edit',
      accountAccessEditorWithParams: 'Account access editor {json}',
      merchantAccessCredentials: 'Merchant access credentials',
      merchantAccessCredentialsWithParams: 'Merchant access credentials {json}',
      generateName: 'Generate name',
      globalId: 'Global ID',
      createAccount: 'Create account',
      create: 'Create',
      save: 'Save',
      merchantAccountsList: 'The list of merchant accounts',
      merchantAccountUpdatedSuccessfully: 'Account **%{name}** updated',
      merchantAccountCreatedSuccessfully: 'Account **%{name}** created',
      merchantAccountDeletedSuccessfully: 'Account **%{name}** deleted',
      deleteAccount: 'Delete account',
      gateway: 'Gateway',
      gateways: 'Gateways',
      accountDelete1: 'Account',
      accountDelete2: 'will be permanently deleted. This action cannot be undone.',
      accountDeleteError: 'Failed to delete merchant account',
    },
    merchants: {
      allAccessSettings: 'All access settings have been created successfully!',
      afterAccessSettingsConfirmation:
        'After you confirm enabling access to settings, the record %{recordName} will be available for editing for the selected user. The access rectriction will be automatically disabled according to the specified access end date.',
      addAccess: 'Add access',
      accessExpirationDate: 'Access end date',
      responsiblePerson: 'Responsible',
      ruleWillBeDelete: 'Rule %{name} will be permanently deleted. This action cannot be undone',
      deleteRule: 'Delete rule',
      ruleDeleted: 'Rule **%{name}** deleted',
      rulesHaveNotBeen: 'Rules have not been added for the merchant %{merchantName}',
      rulesOfMerchant: 'Rules of merchant',
      activeStatus: 'Active',
      accounts: 'Accounts (%{total})',
      providerSettingsTotal: 'Настройки провайдеров (%{total})',
      providerSettings: 'Настройки провайдеров',
      providerSettingsCreate: 'Добавление настроек провайдера',
      providerSettingsEdit: 'Изменение настроек провайдера',
      providerSettingsAlert: 'У мерчанта %{name} нет связанных провайдеров',
      providerSettingsSuccess: 'Provider setting added for **%{name}**',
      providerSettingsSuccessEdit: 'Provider setting updated for **%{name}**',
      limits: 'Limits (%{total})',
      commissions: 'Commissions (%{total})',
      rules: 'Rules (%{total})',
      notification: 'Notifications (%{total})',
      accesses: 'Access (%{total})',
      merchantManagement: 'Manage merchant',
      merchantCreated: 'Merchant **%{name}** created',
      merchantEdited: 'Merchant **%{name}** edited',
      merchantDeleted: 'Merchant **%{name}** deleted',
      merchantRestoried: 'Merchant **%{name}** restored',
      merchantArchived: 'Merchant **%{name}** archived',
      restoreMerchant: 'Restore merchant',
      merchantWillBeActivated1: 'The merchant',
      merchantWillBeActivated2:
        'will be activated and become available for configuration in the system and for generating financial reports.',
      toPassApiKeyValue: 'to pass the API key',
      useInternalService: 'Use the internal service',
      merchants: 'Merchants',
      kuberaClientAccount: 'The Kubera client account',
      noMerchantsAvailableForUser:
        'No merchants are available for user %{firstName} %{lastName}. Please contact your system administrator to configure access settings',
      merchantWillBeDeletedPermanently1: 'The merchant',
      merchantWillBeDeletedPermanently2: 'will be deleted. This action cannot be undone',
      merchantDeletion: 'Delete merchant',
      backToMerchantsList: 'Back to the list of merchants',
      name: 'Name',
      alias: 'Alias',
      state: 'Status',
      company: 'Companies',
      referrals: 'Referrals',
      notificationKey: 'Notification key',
      notificationLanguage: 'Notification language',
      channelIdFor: 'Channel ID for',
      notificationsMismatch: 'missMatch notifications',
      partner: 'Partner',
      platform: 'Platform',
      createdAt: 'Created',
      updatedAt: 'Updated',
    },
    orderAdjustmentsReport: {
      adjustmentRequestCreatedSuccessfully: 'The adjustment request has been created successfully',
      dialog: {
        exportTitle: 'Export report',
      },
      notify: {
        exportStarted:
          'The export file for the order adjustments report is being generated %{emailPart}',
        sentToEmail: ' and will be sent to your email',
      },
      filters: {
        time: 'Time',
        createdAtPeriod: 'Creation time / period',
        adjustmentType: 'Operation types',
        impactToBalance: 'Balance impact',
        adjustmentStatus: 'Operation statuses',
        user: 'Authors / Initiators',
        requestId: 'Request ID',
      },
      searchDialogTitle: 'Search for related adjustments by order',
      searchDialogText: 'Perform search for related operations for order %{id}?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      commentDialogTitle: 'Comment for operation %{id}',
      returnToList: 'Return to list',
      searchLinks: 'Search for links',
      viewComment: 'View the comment',
      author: 'Author',
      createdAt: 'Created',
      appliedAt: 'Applied',
      method: 'Method',
      merchant: 'Merchant',
      provider: 'Provider',
      client: 'Client',
      orderStatusChange: 'Order status change',
      gateway: 'Gateway',
      adjustmentDeclineReason: 'Decline reason for adjustment',
      orderDirection: 'Order direction',
      amount: 'Amount',
      adjustmentStatus: 'Adjustment status',
      clientBalanceChange: 'Player balance change',
      hasBalanceActivity: 'Has balance activity',
      noBalanceActivity: 'No balance activity',
      adjustmentType: 'Adjustment type',
      title: 'Report on order adjustments',
      reset: 'Reset',
      infoAlertTitle: 'Report on adjustments',
      infoAlertPart1: 'To view the report on order adjustments, use the',
      filter: 'Filter',
      infoAlertPart2: 'or',
      searchById: 'Search by ID',
      infoAlertPart3:
        'If you need the list of adjustments for a specific order, you can use the data from system notifications or the corporate messenger Reddy.',
      orderId: 'order ID',
      rejectReason: 'Reject reason',
      orderAmount: 'Order amount',
      amountChange: 'Amount change',
      orderStatus: 'Order status',
      statusChange: 'Status change',
      clientId: 'Customer ID',
      direction: 'Direction',
    },
    orderAdjustments: {
      excludeDialog: {
        title: 'Exclude Order from Adjustment',
        messageStart: 'Order',
        messageMiddle: 'with status',
        messageEnd: 'will be excluded from the adjustment.',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      excludeGroupDialog: {
        title: 'Exclude selected orders from the adjustment',
        message: '%{selectedOrdersAmount} orders wil be excluded from this adjustment.',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      resetDialog: {
        title: 'Reset preview results',
        message: 'After confirmation, search settings and the list of found IDs will be reset.',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      submitDialog: {
        title: 'Submit order adjustment',
        message: 'After confirmation, the adjustment data will be sent for processing.',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      bulkActions: {
        comment: 'Comment',
        exclude: 'Exclude',
      },
      contextMenu: {
        editAmount: 'Edit amount',
        comment: 'Comment',
        exclude: 'Exclude',
      },
      successDialog: {
        title: 'Adjustments have been sent successfully',
        message:
          'When processing is complete, you will receive notifications in the admin panel and Reddy with the results.',
        close: 'Close',
        goToReport: 'Go to report on adjustments',
      },
      adjustmentOrderAmount: 'Order amount adjustment',
      adjustmentStatusToSuccess: 'Set status "Successful"',
      adjustmentStatusToRefund: 'Set status "Refund"',
      adjustmentStatusToChargeback: 'Set status "Chargeback"',
      adjustmentStatusToFailure: 'Set status "Failed"',
      adjustmentStatusToCancelled: 'Set status "Cancelled"',
      allowedStatusSuccess: 'Allowed for the orders with the status "Successful"',
      allowedStatusPendingFailedExpired:
        'Allowed for the orders with the statuses "Pending", "Failed" and "Expired"',
      allowedStatusPreparedSuccessPending:
        'Allowed for the orders with the statuses "Prepared", "Successful" and "Pending"',
      allowedStatusCreated: 'Allowed for the orders with the status "Created"',
      adjustmentType: 'Adjustment type',
      required: 'Required',
      adjustmentTypeMessages: {
        orderAmount:
          'This adjustment is allowed for the orders with status "Successful". Once applied, the transaction amount will be changed.',
        statusToSuccess:
          'This adjustment is allowed for the orders with status "Pending", "Failed" and "Expired". Once applied, the order will be set to the status "Successful".',
        statusToRefund:
          'This adjustment is allowed for the orders with status "Successful". Once applied, the order will be set to the status "Refund".',
        statusToChargeback:
          'This adjustment is allowed for the orders with status "Successful". Once applied, the order will be set to the status "Chargeback".',
        statusToFailure:
          'This adjustment is allowed for the orders with status "Prepared", "Successful" and "Pending". Once applied, the order will be set to the status "Failed".',
        statusToCanceled:
          'This adjustment is allowed for the orders with status "Created". Once applied, the order will be set to the status "Cancelled".',
      },
      impactToBalanceMessages: {
        true: 'The impact on the player`s account balance must be considered for adjusted orders.',
        false: 'Order adjustments will not affect the player`s account balance.',
      },
      adjustmentDialogTitle: 'Order adjustment settings',
      balanceMovementLabel: 'Impact to balance',
      balanceMovementTrue: 'With funds movement on player balance',
      balanceMovementFalse: 'Without funds movement on player balance',
      submitButton: 'Submit',
      cancelButton: 'Cancel',
      header: {
        filterById: 'Filter by ID',
        adjustmentSettings: 'Adjustment settings',
        info: 'Additional information',
        submitSuccess: 'Adjustment data successfully sent',
        goToReport: 'Go to report',
        submitInfo:
          'After the order adjustment process is completed, you will receive notifications in the admin panel and Reddy with the processing results.',
      },
      filters: {
        clear: 'Reset',
        apply: 'Apply',
        dialogTitle: 'Filter by ID',
        addFilters: 'Specify IDs to search for orders',
        notFoundIds: 'Some IDs were not found',
      },
      datagrid: {
        merchantId: 'Merchant ID',
        created: 'Created at',
        amount: 'Amount',
        orderOrTx: 'order / transaction',
        direction: 'Direction',
        status: 'Status',
        client: 'Customer',
        merchant: 'Merchant',
        provider: 'Provider',
        paymentSystem: 'Payment system',
        gateway: 'Gateway',
        method: 'Method',
        comment: 'Comment',
        exclude: 'Exclude',
      },
      dialogs: {
        groupCommentDialog: {
          title: 'Comment for group of orders',
          label: 'Comment',
          buttons: {
            reset: 'Reset',
            save: 'Save',
            cancel: 'Cancel',
          },
        },
        commentDialog: {
          title: 'Adjustment Comment',
          label: 'Comment',
          buttons: {
            clear: 'Clear',
            save: 'Save',
            cancel: 'Cancel',
          },
        },
        comment: {
          title: 'Order Comment',
          submit: 'Save',
        },
        groupComment: {
          title: 'Add comment to selected orders',
          submit: 'Save',
        },
        amount: {
          title: 'Change the order amount',
          submit: 'Save',
          clear: 'Reset',
        },
        adjustment: {
          title: 'Adjustment Settings',
          submit: 'Continue',
        },
        submit: {
          title: 'Confirm Adjustment',
          submit: 'Submit',
        },
        success: {
          title: 'Adjustment Successful',
          ok: 'Done',
        },
        reset: {
          title: 'Reset Filters',
          submit: 'Reset',
        },
        reference: {
          title: 'Reference Information',
        },
        exclude: {
          title: 'Exclude Order',
          submit: 'Exclude',
        },
      },
    },
    adjustments: {
      massOrderAdjustment: 'Mass order adjustment',
      searchById: 'Search by ID',
      preview: 'Preview',
      previewDescription:
        'To preview, search by a single ID or a list of order IDs. If you need to form the list of "Orders" on broader parameters, go to the "Orders" section.',
    },
    common: {
      emailRequiredInProfile:
        'To receive the report by email, it is necessary to specify an email address in your profile settings. Please contact the system administrator',
      serverError: 'Server error',
      ru: 'Russian',
      en: 'English',
      updated: 'Updated',
      merchantAccount: 'Merchant account',
      approved: 'Approved',
      yes: 'Yes',
      no: 'No',
      error: 'Error',
      createdAt: 'Created',
      updatedAt: 'Applied',
      requestLogs: 'Request logs',
      notifications: 'Notifications',
      generalInformation: 'General information',
      idTransferredToTheProviderSide: 'The ID has been transferred to the Provider side',
      noResults: 'No results found',
      view: 'View',
      activityChanged: 'Activity changed',
      and: 'and',
      or: 'or',
      info: 'Info',
      files: 'Files',
      comments: 'Comments',
      of: 'of',
      loading: 'Loading...',
      fileDownloadFailure: 'Failed to download the file',
      from: 'from',
      to: 'to',
      fileDeleted: 'Attachment deleted',
      fileUploaded: 'File received. Data validation and upload in progress.',
      emptyMerchantAccessAlert:
        'User %{firstName} %{lastName} does not have access to any merchants. Contact the system administrator to configure access.',
    },
    table: {
      comment: 'Comment',
      actived: 'Active',
      executionTime: 'Execution time',
      countryCode: 'Country code',
      creationTime: 'Created',
      updateTime: 'Updated',
      createdAt: 'Created',
      updatedAt: 'Updated',
      lastUpdatedAt: 'Last updated',
      amount: 'Amount',
      currency: 'Currency',
      direction: 'Direction',
      method: 'Method',
      status: 'Status',
      merchant: 'Merchant',
      client: 'Client',
      clientData: 'Client data',
      provider: 'Provider',
      gateway: 'Gateway',
      declineReason: 'Decline reason',
      name: 'Name',
      merchantsAmount: 'Number of Merchants',
      entity: 'Entity',
      entities: 'Entities',
      entityId: 'Entity ID',
      user: 'User',
      ip: 'IP adress',
      eventType: 'Event type',
      email: 'Email',
      role: 'Role',
      description: 'Description',
      order: 'Order',
      sortOrder: 'Sort order',
      trafficPercentage: 'Traffic percentage',
      active: 'Active',
      account: 'Account',
      commissions: 'Commissions',
      lastActivity: 'Last activity',
      alias: 'Alias',
      logo: 'Logo',
      idKubera: 'Kubera ID',
      idMerchant: 'Merchant ID',
      idProvider: 'Provider ID',
      badge: 'Method badge',
    },
    buttons: {
      approved: 'Approve',
      approval: 'Submit for approval',
      activate: 'Activate',
      annul: 'Annul',
      goTo: 'View',
      info: 'Info',
      loading: 'Loading',
      inArchive: 'Move to archive',
      restore: 'Restore',
      accessDenied: 'No access',
      showValue: 'Show',
      archived: 'Archive',
      add: 'Add',
      approve: 'Approve',
      reject: 'Reject',
      close: 'Close',
      show: 'View details',
      copy: 'Copy',
      copied: 'Copied',
      copyFailed: 'Copy failed',
      export: 'Export',
      saveFilter: 'Save filter settings',
      apply: 'Apply',
      reset: 'Reset',
      cancel: 'Cancel',
      delete: 'Delete',
      back: 'Back',
      continue: 'Continue',
      exportTo: 'Export to',
      searchById: 'Search by ID',
      filter: 'Filter',
      columns: 'Columns',
      columnsSetupAvailable: 'Column settings are available',
      afterReportGenerated: 'after the report is generated',
      availableActions: 'Available actions',
      favorite: 'My filters',
      noSettings: 'There are no settings',
      addFilterSettingsViaFilter: 'Add the filter settings via the “Filter”',
      userActions: 'User actions',
      edit: 'Edit',
      save: 'Save',
      confirm: 'Confirm',
      disable: 'Disable',
      create: 'Create',
      archive: 'Archive',
      unarchive: 'Unarchive',
      view: 'View',
      collapse: 'Collapse',
    },
    notification: {
      error: 'Error',
      unknownError: 'Unknown error',
    },
    filter: {
      ruleId: 'Rule ID',
      defaultDateRange: 'Default date range',
      markAsFavourite: 'Mark as favourite',
      partners: 'Partner',
      platform: 'Platform',
      referrals: 'Referrals',
      company: 'Company',
      companies: 'Companies',
      state: 'Status',
      clearFilter: 'Reset filter',
      creationTime: 'Creation date',
      enterId: 'Enter the ID and press the Enter button',
      enterOrderIds: 'Type one or more order IDs. Press Enter after each ID',
      searchById: 'Search by ID',
      idKubera: 'Kubera ID',
      idMerchant: 'Merchant ID',
      idProvider: 'Provider ID',
      idAny: 'Any ID',
      idNotFound: 'IDs not found',
      filter: 'Filter',
      presetCreated: 'Filter preset %{name} has been created',
      presetDeleted: 'Filter preset %{name} has been deleted',
      favorite: 'My filters',
      filterSettings: 'The filter setting',
      willBeDeletedFromLocalStorage:
        'will be permanently deleted from local storage. This action cannot be undone',
      deleteFilterSettings: 'Delete the filter settings?',
      fav: 'Favourite',
      creationTimePeriod: 'Creation date / time range',
      anyOrderId: 'Any order ID',
      merchant: 'Merchant',
      merchants: 'Merchants',
      provider: 'Provider',
      providers: 'Providers',
      gateways: 'Gateways',
      methods: 'Methods',
      direction: 'Direction',
      status: 'Status',
      statuses: 'Statuses',
      currency: 'Currency',
      currencies: 'Currencies',
      conversionCurrency: 'Conversion currency',
      customer: 'Client',
      amountFrom: 'Amount from',
      amountTo: 'Amount to',
      declineReason: 'Decline reason',
      matchRejectReason: 'Exact match on decline reason',
      appliedFilterTooBroad:
        'The applied filter is too broad, so only 1000 orders are shown. Use export to download all records',
      name: 'Name',
      period: 'Date range: from/to',
      dateRange: 'Date range',
      entity: 'Entity',
      entities: 'Entities',
      entityId: 'Entity ID',
      role: 'Role',
      roles: 'Roles',
      user: 'User',
      users: 'Users',
      eventType: 'Event type',
      eventTypes: 'Event types',
      active: 'Active',
      method: 'Method',
      clientId: 'Client ID',
      country: 'Country',
      countries: 'Countries',
      emptyList: 'To generate a report, select a date range and required parameters in filters.',
      noMerchantsAvailableForUser:
        'No merchants are available for user %{firstName} %{lastName}. Please contact your system administrator to configure access settings.',
      reportGeneratedForPeriod: 'The report has been generated for the period',
      gateway: 'Gateway',
      category: 'Category',
      categories: 'Categories',
      critical: 'Critical',
      language: 'Language',
      selectMerchantFirst: 'Select a merchant first',
      selectProviderFirst: 'Select a provider first',
    },
    validation: {
      onlyNumbers: 'Only numeric values are allowed',
      onlyPositive: 'Values must be positive',
      maxItems: 'Maximum of %{count} items',
      minGreaterThanMax: 'The "MIN" value cannot be greater than the "MAX" value',
      enterNumber: 'Enter a number',
      required: 'Required',
      requiredField: 'Required field',
      maxPeriod1year: 'The maximum period is 1 year.',
      maxPeriod31Days: 'The maximum date range for generating widgets is 31 days.',
      wrongDomain: 'Wrong domain',
      string: {
        maxLength: 'This value is too long. It must contain %{max} characters or fewer.',
        minLength: 'This value is too short. It must contain %{min} characters or more.',
      },
      number: {
        isNumber: 'Must be a number',
        noNegative: 'Must not be negative',
        integer: 'Must be an integer',
        greaterThan: 'Must be greater than %{min}',
        lessThan: 'Must be less than %{max}',
      },
    },
    login: {
      numberReddy: 'Reddy Number',
      password: 'Password',
      rememberMe: 'Remember me',
      credentials: 'Sign in to Kubera',
      newPassword: 'Create a new password',
      secondFactor: 'Two-factor authentication',
      forgotPassword: 'Forgot the password?',
      signIn: 'Sign in',
      invalidNumberOrPassword: 'Incorrect Reddy numer or password',
      codeFrom: 'Reddy code',
      requestNewCode: 'Request a new code',
      send: 'Verify',
      codeResendUnavailable: 'You can"t request a new code right now. Please try again later.',
      codeAttemptsExceeded: 'Too many attempts. Try again in 30 minutes',
      passwordsDoNotMatch: 'Passwords don"t match',
      newPass: 'New password',
      confirmPass: 'Confirm new password',
    },
    statuses: {
      created: 'Created',
      prepared: 'Prepared',
      pending: 'Pending',
      success: 'Successful',
      failure: 'Failed',
      cancelled: 'Cancelled',
      expired: 'Expired',
      refund: 'Refund',
      chargeback: 'Chargeback',
      waitingConfirmation: 'Under review',
      active: 'Active',
      archive: 'Archived',
    },
    direction: {
      payment: 'Deposit',
      payout: 'Withdrawal',
      all: 'All directions',
    },
    orders: {
      ordersExportFileIs: 'The order export file is being generated',
      ordersExportFileIsSend: 'and will be sent to your email',
      confirmGoToBulkOrders: 'Open the "Mass adjustment" section for %{selectedIds} orders.',
      goToOrdersAdjustment: 'Proceed to order adjustment',
      ordersAdjustment: 'Adjustment of orders',
      bulkResendNotifications: {
        button: 'Resend notification',
        confirmTitle: 'Resend notifications',
        confirmMessage:
          'Notifications will be resent to the merchant for the selected orders. Orders without previously sent notifications will be skipped.',
        successMessage: 'Notification resend request has been submitted and is being processed.',
      },
      logs: {
        requestType: 'Request type:',
        eventId: 'Event ID:',
        request: 'Request',
        response: 'Response',
        title: 'Request logs',
        empty: 'No request logs',
        createdAt: 'Time',
        statusChange: 'Status change:',
        direction: 'Request direction:',
      },
      notifications: {
        empty: 'No notifications',
        title: 'Notifications',
        tooltipText:
          'You can resend the notification. The request body will be automatically compiled based on the current status values ​​and other order parameters.',
        id: 'ID',
        delivered: 'Delivered',
        attempts: 'Attempt count',
        nextAttempt: 'Next attempt',
        send: 'Send',
        httpRequest: 'URL',
        requestBody: 'Request body',
        response: 'Response',
        status: 'Status',
        sendNotification: 'Send a notification',
      },
      transactions: {
        history: 'Transaction history',
        noTransactions: 'No transactions',
        transactionId: 'Transaction ID',
        createdAt: 'Created at',
        transactionType: 'Transaction type',
        transactionAmount: 'Transaction amount',
        currency: 'Currency',
        commissionRule: 'Commission rule',
        commissionAmountOrderCurrency: 'Commission amount',
        commissionAmountRuleCurrency: 'Commission amount',
        commissionOrderCurrency: 'in the currency of the order',
        commissionRuleCurrency: 'in the currency of the rule',
        noValue: 'No',
      },
      statuses: {
        history: 'Status history',
        noStatuses: 'No statuses',
        statusId: 'Status ID',
        orderStatus: 'Order status',
        changedAt: 'Changed at',
      },
      urls: {
        return: 'Return URL',
        pending: 'Pending URL',
        success: 'Success URL',
        failure: 'Failure URL',
        notification: 'Notification URL',
        resources: 'Resources',
      },
      bulkResendNotificationsGuide: {
        title: 'Mass notification resend guide',
        intro1:
          'The mass notification resend feature allows you to resend merchant notifications for multiple selected orders at once.',
        intro2:
          'Use this feature when you need to send order-related information to merchants again for a group of orders.',
        stepsTitle: 'To perform a mass notification resend:',
        step1: 'Select one or more orders from the order list.',
        step2: 'In the bulk actions panel, click "Resend notifications".',
        step3: 'Confirm the action in the modal window.',
        afterConfirmation:
          'After confirmation, the request will be submitted for processing. Notification resend is performed in the background, so you do not need to wait for each order to be processed.',
        limitTitle: 'Limit',
        limit:
          'You can resend notifications for up to 100 orders at a time. If you need to resend notifications for more than 100 orders, divide the list of orders into groups of 100 orders or fewer.',
        scopeTitle: 'Which orders will be processed',
        scope:
          'Notifications will be resent only for orders that already have previously sent merchant notifications. If a selected order does not have any previously sent notifications, it will be skipped. This is not considered an error and does not block notification resend for the remaining selected orders.',
        availabilityTitle: 'Availability',
        availability:
          'Mass notification resend is available only to users with the "Admin" and "Payments department manager" roles.',
        closeButton: 'Close',
      },
      orderAdjustment: 'Order adjustment',
      amountAdjustment: 'Amount Adjustment',
      providerDetails: 'Provider details',
      orderNum: 'Order #%{originId}',
      merchantDetails: 'Merchant details',
      theOrderIsRejected: 'The order is rejected',
      testModeWarning5:
        'The order #%{originId} is rejected. You can go to the gateway settings %{gatewayName} to change them.',
      theOrderIsApproved: 'The order is approved',
      testModeWarning4:
        'The order #%{originId} has been approved successfully. You can go to the gateway settings %{gatewayName} to switch it to the standard operating mode.',
      proceedToTheGatewaySettings: 'Proceed to the gateway settings',
      orderRejection: 'Order rejection',
      testModeWarning3:
        'The order #%{originId} was created via the gateway %{gatewayName}, which is currently in test mode. Order rejection must be performed after its full review, during which errors were found.',
      orderApproval: 'Order approval',
      testModeWarning2:
        'The order #%{originId} was created via the gateway %{gatewayName}, which is currently in test mode. Please review the order and approve or reject it. Order approval must be performed only after its full and successful review.',
      testModeWarning:
        'The order #%{originId} was created via the gateway %{gatewayName}, which is currently in test mode. Please review the order and approve or reject it.',
      orderReview: 'Order review',
      failedToRejectTheOrder: 'Failed to reject the order',
      failedToApproveTheOrder: 'Failed to approve the order',
      theOrderHasBeenRejectedSuccessfully: 'The order has been rejected successfully',
      theOrderApprovedSuccessfully: 'The order has been approved successfully',
      commentOper: 'Comment on the operation #%{originId}',
      initiatorAuthor: 'Initiator / Author',
      statusChange: 'Status change',
      amountChange: 'Amount change',
      adjustmentStatus: 'Adjustment status',
      playerBalanceTransactions: 'Player balance transactions',
      adjustmentType: 'Adjustment type',
      adjustmentId: 'Adjustment ID',
      orderAdjustments: 'Order adjustments',
      noOrderAdjustments: 'No order adjustments',
      addInfo: 'Additional information',
      info: 'Information',
      orderDetails: 'Order details',
      ordersRegisteredInStatuses:
        'During the reporting period %{reportPeriod} for the direction "%{direction}" the system registered the orders in the following statuses:',
      copySummary: 'Copy summary',
      notCompleted: 'Not processed',
      completed: 'Processed',
      total: 'Total',
      ordersSummaryForPeriod: 'Order summary for the period',
      summaryForPeriod: 'Summary for the period',
      reportGeneratedForPeriod: 'The report has been generated for the period',
      orders: 'Orders',
      exportReport: 'Download the report',
      toGenerateReportSelect:
        'To generate a report, select saved parametres from "My filters" or set new parametres in filters.',
      reportWillBeConverted:
        'After confirmation, the report will be converted to %{exportType} and available in "My downloads".',
      duplicateEmailSending: 'Also send a copy to',
      summary: {
        created: 'Created',
        prepared: 'Prepared',
        pending: 'Pending',
        success: 'Successful',
        failure: 'Failed',
        cancelled: 'Cancelled',
        refund: 'Refund',
        chargeback: 'Chargeback',
        expired: 'Expired',
        waitingConfirmation: 'Under Review',
        executedOrderCount: 'Executed',
        notExecutedOrderCount: 'Not Executed',
        noValue: 'No value',
        total: 'Total',
        period: 'Period',
      },
    },
    restorePassword: {
      setReddyNumber: 'Enter Reddy number to reset the password',
      notFoundByNumber: 'We couldn’t find an account with this Reddy number',
    },
    companies: {
      titleText: 'Companies',
      tooltipText: 'The legal entity that the merchant belongs to.',
      activeStatus: 'Active',
      details: 'Company details',
      editTitle: 'Edit company',
      createTitle: 'Create company',
      deleteTitle: 'Delete company',
      deleteDetails1: 'After deletion, the company',
      deleteDetails2: 'will be unavailable for recovery.',
      returnToList: 'Return to the list of companies',
      companyActivated1: 'Company',
      companyActivated2:
        'will be moved to an active state and become available for system configuration and financial reporting.',
      companyUnarchiveTitle: 'Company restoration',
      companyArchiveTitle: 'Archive Company',
      companyArchiveDetails1: 'Company',
      companyArchiveDetails2:
        'will be moved to the archive and will no longer be available for system configuration or financial reporting. If necessary, this company’s functionality can be restored.',
    },
    userActions: {
      titleText: 'User actions',
      details: 'Action details',
      jsonSchema: 'JSON schema for the event',
    },
    commissions: {
      edited: 'Commission %{name} has been edited',
      deleted: 'Commission %{name} has been deleted',
      details: 'Commission details',
      conditions: 'Commission conditions',
      recalculationTasks: 'Commission recalculation tasks',
      type: 'Commission type',
      relatedCommissions: 'Related commissions',
      activityPeriodFrom: 'Activity period from',
      activityPeriodTo: 'Activity period to',
      transactionTypes: 'Transaction types',
      zeroed: 'Zeroed commission',
      percent: 'Percent',
      fixed: 'Fixed',
      max: 'Max',
      min: 'Min',
      calculationMethod: 'Calculation method',
      noFiles: 'No files',
      noComments: 'No coments',
      statusChange: 'Commission **%{name}** status changed to **%{status}**',
      inApproval: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      implemented: 'Activated',
      annulled: 'Cancelled',
      archived: 'Archived',
    },
    commissionsRecalculation: {
      createDialog: {
        title: 'Create a commission recalculation task',
        message:
          'Select the time zone, date and time. After the commission is approved, the recalculation task will start at the scheduled time. ',
        date: 'Recalculation start date / time',
        error: 'Error',
        success: 'Commission recalculation job **%{name}** created',
      },
      successDialog: {
        title: 'Commission recalculation task created',
        message:
          'After the commission is approved, a finance manager can start this commission recalculation task for orders.',
        show: 'View task',
      },
      showDialog: {
        title: 'Commission recalculation task',
        period: 'Recalculation period',
        days: 'Number of calendar days',
        amount: 'Number of orders to be recalculated',
      },
      deleteDialog: {
        title: 'Delete commission recalculation task',
        message:
          'The commission recalculation task will be permanently deleted. This action cannot be undone.',
        success: 'Commission recalculation job **%{name}** deleted',
      },
      editDialog: {
        success: 'Commission recalculation job **%{name}** updated',
      },
      startDialog: {
        success: 'Commission recalculation job **%{name}** started',
      },
    },
    merchantAccount: {
      details: 'Merchant account details',
      partners: 'Partner',
      merchantIdEnabled: 'Merchant ID enabled',
      credentials: 'Merchant account credentials {json}',
    },
    gatewayRules: {
      titleText: 'Rules',
      noRulesAlert:
        'There are no available rules for user %{firstName} %{lastName}. Please contact the access settings administrator.',
      trafficPercentage: 'Traffic percentage',
      condition: 'Condition',
      expression: 'Expression',
      mappings: 'Mappings',
      rules: 'Rules',
      conditionTooltipText: 'To change the condition, go to the rule editing page',
      mappingTooltipText:
        'When viewing, only the traffic percentage can be edited. To change other mapping properties, go to the rule editing page',
      activityChangeSuccess: 'Activity change success',
      activityChangeError: 'Rule activity changing error',
      ruleIsActive: 'The rule is active',
      ruleIsInactive: 'The rule is not active',
      ruleEnabled: 'Rule **%{name}** enabled',
      ruleDisabled: 'Rule **%{name}** disabled',
      enableRule: 'Enable the rule',
      disableRule: 'Disable the rule',
      enableMethod: 'Enable method',
      disableMethod: 'Disable method',
      enableMethodMessage:
        'The method %{methodName} for the %{gatewayRuleName} rule will operate according to the current settings after activation is confirmed.',
      disableMethodMessage:
        'The method %{methodName} for the %{gatewayRuleName} rule will be disabled.',
      enableRuleMessage:
        'After activation is confirmed, the rule %{name} will operate according to the current settings',
      disableRuleMessage: 'The rule %{name} will be temporarily disabled',
      methodMerchantsName: 'Method name for merchant',
      mappingIsActive: 'The mapping is active',
      mappingIsInactive: 'The mapping is not active',
      mappingDetails: 'Mapping details',
      mappingEdit: 'Edit mapping description',
      trafficChangeSuccess: 'Traffic percentage changed',
      trafficChange: 'Edit traffic percentage',
      trafficRule:
        '0 — the gateway will be disabled.\nIn all other cases, the traffic will be distributed in proportion to the total sum of all traffic percentage values.',
      ruleDeleted: 'Rule deleted',
      deleteRule: 'Delete rule',
      deleteMapping: 'Delete mapping',
      ruleDeleteWarning:
        'The rule with ID:%{id} for merchant %{merchantName} will be permanently deleted and cannot be restored.',
      addGateway: 'Add gateway',
      deleteGateway: 'Delete gateway',
      deleteExpression: 'Delete expression',
      deleteGroup: 'Delete group',
      deleteCondition: 'Delete condition',
      group: 'Group',
      goToOrders: 'Go to orders',
      ruleDetails: 'Rule details',
      editRule: 'Edit rule',
      createRule: 'Create rule',
      ruleEdited: 'The rule edited',
      saveRule: 'Save rule',
      ruleCreated: 'The rule сreated',
      editRuleBtn: 'Edit rule',
      deleteRuleBtn: 'Delete rule',
      createRuleBtn: 'Create rule',
      active: 'Active',
      addCondition: '1. Add condition',
      addMappings: '2. Add mappings',
      addConditionBtn: 'Add condition',
      addMappingBtn: 'Add mapping',
      addConditionWarn:
        "If you don't add a condition, the rule will apply to all of the merchant's clients.",
      commissionType: 'Type',
      commissionStatus: 'Status',
    },
    orderConversion: {
      orderConversion: 'Order conversion monitoring',
      orderConversionListOrdersTitle: 'Order status summary',
      orderConversionMetricDescription:
        'Order conversion is a metric that shows the percentage of orders in the statuses "Success", "Pending" or "Cancelled" for the selected period.',
      filterSelectMerchantToViewStats:
        'Please, select a merchant in the filter to view statistics.',
      hours1: '1 hour',
      hours4: '4 hours',
      hours8: '8 hours',
      hours12: '12 hours',
      minutes60: '60 minutes',
      hours3: '3 hours',
      hours5: '5 hours',
      hours7: '7 hours',
      conversion: 'Conversion',
      thresholds: 'Treshholds',
      overallConversionForSelectedGateways:
        'Overall conversion for all gateways selected in the filter.',
      autoupdate: 'Auto-update',
      gatewayConverionSuccessAlert:
        'Conversion of orders by gateways has been generated for the period: %{period}',
      orderConverionSuccessAlert:
        'Order conversion summary has been generated for the period: %{period}',
      countLabels: {
        orderCount: 'Total orders',
        created: 'Created',
        pending: 'Pending',
        success: 'Successful',
        failure: 'Failed',
        cancelled: 'Cancelled',
        expired: 'Expired',
        refund: 'Refund',
        chargeback: 'Chargeback',
        prepared: 'Prepared',
      },
      showDeviationsOnly: 'Show deviations only',
      gatewaysList: 'Gateways',
      enableAutoupdate: 'Enable auto-update',
      enableAutoUpdateDescription:
        'When enabled, conversion monitoring data will update in the background for the last',
      disableAutoupdate: 'Disable auto-update',
      disableAutoupdateDescription: 'Auto-update will be paused.',
      editThresholds: 'Edit thresholds',
      addThresholds: 'Add thresholds',
      deviations: 'Deviations',
      gatewayNotifications: 'Gateway notifications',
      enableGatewayNotifications: 'Enable gateway notifications',
      enableGatewayNotificationsInfo:
        'Gateway notifications for %{id} %{gateway} will be sent according to the notifications settings of the merchant %{merchant}.',
      disableGatewayNotifications: 'Disable gateway notifications',
      disableGatewayNotificationsInfo:
        'Gateway notifications for %{id} %{gateway} will be disabled for merchant %{merchant} after you confirm.',
      createThresholdSettingsForMonitoring: 'Create threshold settings for monitoring',
      editThresholdSettingsForMonitoring: 'Edit threshold settings for monitoring',
      maxAllowedDeviationFromAvg14DaysDescription:
        'According to the configured thresholds, the system will determine the maximum allowed deviation from statistical averages, calculated on the particular gateway for 14 days.',
      setupGuide: 'Setup guide',
      settingsCreatedSuccessfully: 'Setting for gateway **%{gateway}** created',
      settingsUpdatedSuccessfully: 'Setting for gateway **%{gateway}** updated',
      settingsDeletedSuccessfully: 'Setting for gateway **%{gateway}** deleted',
      notificationsUpdatedSuccessfully: 'Notifications have been updated successfully',
      minimumNumberOfOrders: 'Minimum number of orders',
      minimumHourlyOrderThresholdReddyNotifications:
        'Minimum hourly order threshold to send notifications to Reddy when deviations are detected',
      successfulOrdersDeviationPercentage: 'Deviation percentage for successful orders (%)',
      orderConversionBelowAveragePercentagePoints:
        'Enter how many percentage points the order conversion may be below average',
      cancelledOrdersDeviationPercentage: 'Deviation percentage for cancelled orders (%)',
      conversionBelowAvgPctPoints:
        'Enter how many percentage points the order conversion may be above average',
      queueOrdersDeviationPercentage: 'Deviation percentage for orders in queue (%)',
      conversionAboveAvgPctPointsDesc:
        'Enter how many percentage points the order conversion may be above average',
      enableGatewayNotificationsOnDeviation:
        'Enable gateway notifications when there is a deviation from the configured thresholds',
      referenceDialog: {
        monitoringTitle: 'How order conversion monitoring works',
        monitoringDescription:
          'Every 5 minutes the system checks the status of orders for merchants’ active gateways, using data for the last hour. It analyzes noy only current orders, but also orders for the previous periods, and according to the data the system forms average conversion percentage.',
        monitoringValues:
          'As a result, at each check we get two values: the actual value and the average value for the previous periods. When configuring thresholds, the allowable deviations between the actual data and the average value are specified.',
        thresholdsTitle: 'How to configurate thresholds',
        successfulOrdersDeviation: 'Deviation percentage for successful orders:',
        successfulOrdersDesc:
          'determines how many percentage points the actual number of successful orders may be below the average value.',
        positiveStatus: 'Positive',
        positiveDesc: 'the actual is above the average;',
        acceptableStatus: 'Allowed',
        acceptableDesc: 'the actual is below the average, but within the allowed deviation;',
        deviationStatus: 'Deviation',
        deviationDesc:
          'the actual is below the average, and the deviation is above the allowed threshold.',
        cancelledOrdersDeviation: 'Deviation percentage for cancelled orders:',
        cancelledOrdersDesc:
          'determines how many percentage points the actual number of cancelled orders may be above the average value.',
        queuedOrdersDeviation: 'Deviation percentage for orders in queue:',
        queuedOrdersDesc:
          'determines how many percentage points the actual number of orders in intermediate statuses may be above the average value.',
        importantNote: 'It is important to consider',
        thresholdsSensitivity:
          'that threshold configuration can be extremely sensitive to gateways with a small number of orders and less critical for gateways with a large number of orders. It is important to consider when configuring settings because high and low values, for example 10% or 90%, may lead to many notifications.',
      },
    },
    orderConversionCharts: {
      orderGraphs: 'Order graph by providers',
      ordersForPeriod: 'Orders for period:',
      orderRatio: 'Order ratio',
      byProvidersForPeriod: 'by providers for the selected period',
      totalOrders: 'Total orders:',
      status: {
        successful: 'Successful',
        pending: 'Pending',
        failed: 'Failed',
      },
    },
    orderProviderExternalErrors: {
      declineReasonAnalysis: 'Decline reason analysis',
      declineEvents: 'Decline events',
      totalCount: 'Total orders:',
      declineRatio: 'Decline ratio',
      byProvidersForPeriod: 'by providers for the selected period',
      totalOrders: 'Total orders',
      declines: 'Declines',
      summaryForThePeriod: 'summary for the period',
      declineEventsForPeriod: 'Decline events for the period:',
      datagrid: {
        eventId: 'Event ID',
        createdAt: 'Created',
        orderId: 'Order ID',
        category: 'Category',
        critical: 'Critical?',
        declineCode: 'Decline code',
        declineReason: 'Decline reason',
        numberOfOrdersWithReason: 'Number of orders with this reason',
        percentOfDeclinesForSelectedPeriod: '% of declines for the selected period',
        numberOfDeclines: 'Number of declines for the period',
        percentOfDeclines: '% of declines for the period',
        declineReasonsByGateway: 'Decline reasons by gateway',
      },
      summaryDeclineReasonsForGateway:
        'Summary of decline reasons for the gateway %{gatewayName} for the period %{reportPeriod}',
      summaryDeclineReasonsByGateways:
        'Summary of decline reasons by gateway for the period %{reportPeriod}',
      summaryDeclineReasonsByGatewaysDescription:
        'For the period %{reportPeriod} the system registered orders with decline reasons for the following gateways:',
      details: 'Details',
    },
    orderMethods: {
      titleText: 'Test of rules and methods',
      methodName: 'Method name',
      methodType: 'Method type',
      rules: 'Rules',
      amountRequest: 'Amount request',
      depositsNumber: 'Number of deposits',
      clientId: 'Client ID',
      appVersion: 'App version',
      domain: 'Domain',
      infoAlert: 'To start the check, fill in the required filter parameters.',
      rulesDialog: {
        title: 'History of method selection',
        updatedAt: 'Updated',
        ruleName: 'Rule name',
        useInTest: 'Use in the test',
      },
    },
    notificationPopper: {
      allChecked: 'All notifications have been marked as read',
      checkAll: 'Mark all as read',
      download: 'Download',
      orderAmountAdjustmentReady:
        'The request for bulk order adjustment with the type "Order Amount Adjustment" has been successfully completed.',
      orderAmountAdjustmentStart:
        'The request for bulk order adjustment with the type "Order Amount Adjustment" has been successfully prepared for processing.',
      noNotifications: 'No notifications',
      ordersAdjustmentReport: 'Orders adjustment report',
      taskTitle:
        'For merchant %{merchant} with provider %{provider}, the commission recalculation task has been completed. View',
      commission: 'commission',
      notificationStatuses: {
        done: 'ready for download',
        downloaded: 'downloaded',
        failure: 'error during generation',
      },
      reportNames: {
        cumulative: 'Cumulative report',
        transactions: 'Transactions report',
        orders: 'Orders report',
        balance: 'Balance report',
        expenseReport: 'Отчёт по расходам',
        ordersAdjustment: 'Orders adjustment report',
        refundChargeback: 'Refunds and chargebacks report',
        bankOperationPendingStatuses: 'Bank operation requests report',
        bankOperationFinalStatuses: 'Bank operations report',
        importApproveExport: 'Отчёт о некорректных строках файла',
        importRejectExport: 'Отчёт с результатами проверки файла',
      },
      reportDescriptions: {
        importApproveExport:
          'Выполняется загрузка заявок на банковские операции. Будут созданы только корректные заявки на БО. Отчёт об ошибках доступен для скачивания.',
        importRejectExport:
          'Вы отменили загрузку заявок на банковские операции. Для вас сформирован отчёт с результатами проверки файла. Исправьте ошибки и повторите попытку.',
      },
    },
    navMenu: {
      finance: {
        title: 'Finance',
        balanceReport: 'Balance report',
        cumulativeReport: 'Cumulative report',
        ordersReport: 'Transactions report',
        refundChargebackReport: 'Refunds and chargebacks report',
        expenseReport: 'Отчёт по расходам',
        commissions: 'Commissions',
        bankOperations: 'Bank operation requests',
        bankOperationsFinalStatuses: 'Bank operations',
        workTeams: 'Work teams',
        providerAccounts: 'Access settings',
        commissionRecalculationTasks: 'Commission recalculation tasks',
        reconciliation: 'Reconciliation',
      },
      users: {
        title: 'Users',
        users: 'Users',
        roles: 'Roles',
        userActions: 'User actions',
      },
      directories: {
        title: 'Directories',
        companies: 'Companies',
        referrals: 'Referrals',
      },
      companies: {
        title: 'Companies',
      },
      apiClients: {
        title: 'API clients',
      },
      merchants: {
        title: 'Merchants',
      },
      dashboard: {
        title: 'Dashboard',
      },
      monitoring: {
        title: 'Monitoring',
        orderConversion: 'Order conversion',
        orderConversionChart: 'Order graph by providers',
        orderProviderExternalErrors: 'Decline reason analysis',
        monitoringSettings: 'Settings',
      },
      gatewayRules: {
        title: 'Rules',
        gatewayRules: 'Rules',
        orderMethods: 'Verification of the rules and methods',
      },
      orders: {
        title: 'Orders',
        orders: 'Orders',
        orderAdjustments: 'Mass adjustment',
        orderManualCreate: 'Ручное создание заказа',
        orderAdjustmentsReport: 'Report on adjustment',
        bulkUpdate: 'Order status update',
      },
      methods: {
        title: 'Methods',
        methods: 'Methods',
        methodLogos: 'Method logos',
      },
      gateways: {
        title: 'Gateways',
        gateways: 'Gateways',
        limits: 'Limits',
        gatewayDeactivationReasons: 'Gateway deactivation reasons',
      },
      providers: {
        title: 'Providers',
      },
      presets: {
        title: 'Presets',
      },
    },
    datePicker: {
      dateTimeRangeSelection: 'Select the date and time range',
      dateRangeSelection: 'Select the date range',
      rangeStart: 'Start',
      rangeEnd: 'End',
      timezone: 'Time zone',
      timeFrom: 'Start time',
      timeTo: 'End time',
      time: 'Time',
      shortcuts: {
        today: 'Today',
        yesterday: 'Yesterday',
        lastWeek: 'Last week',
        currentWeek: 'Current week',
        lastMonth: 'Last month',
        currentMonth: 'Current month',
        last24Hours: 'Last 24 hours',
        last7Days: 'Last 7 days',
        last30Days: 'Last 30 days',
      },
    },
    methods: {
      details: 'Method details',
      type: 'Method type',
      active: 'Active',
      inactive: 'Inactive',
    },
    dashboard: {
      title: 'Dashboard',
      noResultsAlert: 'No results found. To generate widgets, specify new filter parameters.',
      timeRangeAlert: 'The data is displayed for the last 24 hours: %{timeRange}',
      transactionsSummary: {
        title: 'Completed transaction amounts for the period',
        deposits: 'Deposits',
        withdrawals: 'Withdrawals',
      },
      successfulTransactionsSummary: {
        title: 'Transaction success rate for the period',
        total: 'Total transactions',
        successful: 'Successful',
        refused: 'Declined',
        pending: 'Pending',
      },
      transactionsDynamicSummary: {
        title: 'Trend in completed transaction amounts for the selected period',
        deposits: 'Deposits',
        withdrawals: 'Withdrawals',
        currency: 'Сurrency: %{currency}',
      },
      entitiesSummary: {
        merchant: 'Merchant',
        provider: 'Provider',
        merchantsCardTitle: 'Top merchants',
        providersCardTitle: 'Top providers',
        cardDescription: 'By the number of successful transactions',
        totalTransactions: 'Total orders',
        successfulTransactions: 'Successful orders (conversion)',
      },
    },
    referrals: {
      title: 'Referrals',
      emptyAlert: 'No referrals added. To add a referral, click "Add".',
      refId: 'Referral ID',
      deleteTitle: 'Delete referral',
      deleteDetails: 'Once deleted, referral %{name} will not be available for recovery.',
      showTitle: 'Referral',
      createTitle: 'Create referral',
      editTitle: 'Edit referral',
    },
  },
};
